import { adjustToken } from '../constants'
import { isInFacebookEnv } from 'web-utils/device'
import Adjust from '@adjustcom/adjust-web-sdk'

const advertiseType = import.meta.env.VITE_AD
const config = {
  appToken: adjustToken,
  environment: 'production',
  logLevel: 'verbose'
}

if (!advertiseType) {
  Adjust.initSdk(config)
} else {
  if (!isInFacebookEnv()) {
    Adjust.initSdk(config)
  }
}
